import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import UploadPage from "./pages/UploadPage";
import EditVideoPage from "./pages/EditVideoPage";
import SettingsPage from "./pages/SettingsPage";
import SearchPage from "./pages/SearchPage";
import HashtagPage from "./pages/HashtagPage";
import ChangelogPage from "./pages/ChangelogPage";
import NotFound from "./pages/NotFound";

function EditVideoRoute() {
  const { nip19 } = useParams<{ nip19: string }>();
  if (!nip19) return <NotFound />;
  return <EditVideoPage identifier={nip19} />;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/tag/:tag" element={<HashtagPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/edit/:nip19" element={<EditVideoRoute />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
